import { ScrollArea } from '@/components/ui/scroll-area';
import { Calendar, Music, Star, TrendingUp } from 'lucide-react';
import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const OnThisDaySection = () => {
  const [history, setHistory] = useState([]);
  const [music, setMusic] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchOnThisDay = async () => {
    try {
      const [historyRes, musicRes] = await Promise.allSettled([
        axios.get(`${API}/history/today`),
        axios.get(`${API}/music/today`)
      ]);

      if (historyRes.status === 'fulfilled') setHistory(historyRes.value.data);
      if (musicRes.status === 'fulfilled') setMusic(musicRes.value.data);

      setLoading(false);
    } catch (error) {
      console.error('Error fetching on this day data:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOnThisDay();
  }, []);

  const getCategoryIcon = (category) => {
    switch (category) {
      case 'birth': return <Star size={14} className="category-icon-birth" />;
      case 'death': return <TrendingUp size={14} className="category-icon-death" />;
      default: return <Calendar size={14} className="category-icon-event" />;
    }
  };

  const today = new Date();
  const dateStr = today.toLocaleDateString('en-GB', { day: 'numeric', month: 'long' });

  return (
    <div className="content-card content-card-large" data-testid="onthisday-section">
      <div className="card-header">
        <h2>
          <Calendar size={20} className="inline" /> On This Day - {dateStr}
        </h2>
      </div>
      <ScrollArea className="card-content">
        <div className="onthisday-container">
          {/* History Section */}
          <div className="onthisday-subsection">
            <div className="onthisday-subsection-header">
              <Calendar size={18} />
              <h3>In History</h3>
            </div>
            {loading ? (
              <p className="loading-text">Loading history...</p>
            ) : (
              <div className="history-list">
                {history.slice(0, 5).map((item, index) => (
                  <div key={`${item.year}-${item.text}`} className="history-item" data-testid={`history-${index}`}>
                    <div className="history-year">
                      {getCategoryIcon(item.category)}
                      {item.year}
                    </div>
                    <p className="history-text">{item.text}</p>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Music Section */}
          <div className="onthisday-subsection">
            <div className="onthisday-subsection-header">
              <Music size={18} />
              <h3>In Music</h3>
            </div>
            {loading ? (
              <p className="loading-text">Loading music history...</p>
            ) : (
              <div className="music-history-list">
                {music.slice(0, 5).map((item, index) => (
                  <div key={`${item.year}-${item.artist}-${item.event}`} className="music-history-item" data-testid={`music-${index}`}>
                    <div className="music-event-badge" data-event={item.event.toLowerCase()}>
                      {item.event}
                    </div>
                    <div className="music-info">
                      <div className="music-artist">{item.artist}</div>
                      <div className="music-year">{item.year}</div>
                      <p className="music-details">{item.details}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </ScrollArea>
    </div>
  );
};

export default OnThisDaySection;
